/**
 * One place that decides what counts as a narrow screen, so the sidebar, the
 * chat area and the dialogs cannot disagree about it.
 *
 * 767px is Tailwind's md breakpoint minus one. It is already the point where
 * the sidebar's own classes switch behaviour, so anything that reads this
 * matches what the stylesheet does.
 */
export const NARROW_QUERY = "(max-width: 767px)";

/**
 * Assumes wide when it cannot tell. Every existing user is on a desktop, so a
 * wrong guess in that direction changes nothing for them, while a wrong guess
 * the other way would hide the sidebar on a machine that has room for it.
 */
export function matchesNarrow(win) {
  const target = win || (typeof window !== "undefined" ? window : null);
  if (!target || typeof target.matchMedia !== "function") return false;
  return Boolean(target.matchMedia(NARROW_QUERY).matches);
}

/** The sidebar starts open on a desktop and out of the way on a phone. */
export function initialSidebarOpen(win) {
  return !matchesNarrow(win);
}
